type AppNames = {
  [pathname: string]: string
}

const appNames: AppNames = Object.freeze({
  '/': 'Landing Page',
  '/about': 'About Page',
  '/about/news': 'News Page',
  '/about/news/commonly-asked-questions': 'News Why Charter Page',
  '/activate': 'Card Activation Page',
  '/careers': 'Careers Page',
  '/contact-us': 'Contact Page',
  '/credit-cards/gold-line-visa': 'Gold Line Page',
  '/credit-cards/green-line-visa': 'Green Line Page',
  '/credit-cards/secured-visa': 'Secured Card Page',
  '/credit-cards/silver-line-visa': 'Silver Line Page',
  '/download/apps': 'App Download Page',
  '/legal': 'Legal Page',
  '/legal/autopay-terms': 'Autopay Terms Page',
  '/legal/cardholder-agreements': 'Cardholder Agreements Page',
  '/legal/cash-back-terms': 'Cash Back Terms Page',
  '/legal/consumer-privacy-notice': 'Consumer Privacy Notice Page',
  '/legal/customer-identity-verification-requirements':
    'Customer Identity Verification Requirements',
  '/legal/digital-wallet-terms': 'Digital Wallet Terms Page',
  '/legal/electronic-communications-disclosure-and-consent': 'Ecomm Disclosure Page',
  '/legal/mission-lane-3-travel-dining-gas-earn-cash-back-program-terms-issued-by-tab':
    'Cash Back Program Terms Travel Gas Dining Tab Page',
  '/legal/mission-lane-3-travel-dining-gas-earn-cash-back-program-terms-issued-by-webbank':
    'Cash Back Program Terms Travel Gas Dining WebBank Page',
  '/legal/mission-lane-1-1-5-2-cash-back-program-terms-issued-by-tab-bank':
    'Cash Back Program Terms Standard Tab Page',
  '/legal/mission-lane-1-1-5-2-cash-back-program-terms-issued-by-webbank':
    'Cash Back Program Terms Standard WebBank Page',
  '/legal/mission-lane-up-to-3-dynamic-earn-cash-back-program-terms-issued-by-tab-bank':
    'Dynamic Cash Back Program Terms Tab Page',
  '/legal/mission-lane-up-to-3-dynamic-earn-cash-back-program-terms-issued-by-webbank':
    'Dynamic Cash Back Program Terms WebBank Page',
  '/legal/privacy-and-security': 'Privacy and Security Page',
  '/legal/privacy-policy': 'Privacy Policy Page',
  '/legal/terms-of-use': 'Terms of Use Page',
  '/legal/the-mission-lane-secured-visa-r-credit-card-issued-by-transportation-alliance-bank-inc-dba-tab-bank-2024':
    'Secured Card Tabbank Cardholder Agreements Page',
  '/legal/the-mission-lane-visa-credit-card-issued-by-transportation-alliance-bank-inc-dba-tab-bank':
    'Visa TAB bank Cardholder Agreements Page',
  '/legal/the-mission-lane-visa-credit-card-issued-by-transportation-alliance-bank-inc-dba-tab-bank-2':
    'Visa TAB bank Cardholder Agreements Page (non-early AMF)',
  '/legal/the-mission-lane-visa-credit-card-issued-by-webbank':
    'Visa WebBank Cardholder Agreements Page',
  '/legal/the-mission-lane-visa-credit-card-issued-by-webbank-2':
    'Visa WebBank Cardholder Agreements Page (non-early AMF)',
  '/resources': 'Resources Page',
})

export default appNames
